const {
  REACT_APP_API_URL = 'https://api.uniticexchange.com/api/',
  REACT_APP_FRONTEND_URL = 'https://uniticexchange.com/',
  REACT_APP_BACKEND_URL = 'https://api.uniticexchange.com/',
  REACT_APP_SOCKET_URL = 'https://api.uniticexchange.com/',

  // REACT_APP_API_URL = "http://localhost:3004/api/",
  // REACT_APP_FRONTEND_URL = "http://localhost:3000/",
  // REACT_APP_BACKEND_URL = "http://localhost:3004/",
  // REACT_APP_SOCKET_URL = "http://localhost:3004/",

  REACT_APP_FRONEND_URL_PRINT = 'Unitic',
  REACT_APP_ENSEC = 'U2FsdGVkX1+3j7f6aZ4h5r9Kqv4y7z4S',
  // REACT_APP_CAPTCHA_SITE_KEY = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI", // test key
  REACT_APP_CAPTCHA_SITE_KEY = '6Lf5VuYrAAAAACMhfqYONQHtvu0eKcvA8cj4433r', // prod key

  REACT_APP_APIKEY = 'AIzaSyBjk9GSe86Oz3Kw-rxWpVZxQJ1HByariZ8',
  REACT_APP_AUTHDOMAIN = 'unitic-exchange-26828.firebaseapp.com', //uniticexchange.com
  REACT_APP_PROJECTID = 'unitic-exchange-26828',
  REACT_APP_STORAGEBUCKET = 'unitic-exchange-26828.firebasestorage.app',
  REACT_APP_MESSAGINGSENDERID = '422096896190',
  REACT_APP_APPID = '1:422096896190:web:8dcb92d4af94dc6ca9deef',
  REACT_APP_MEASUREMENTID = 'G-KTRMVJMYB3',
} = process.env
const KEY = {
  V1_API_URL: REACT_APP_API_URL + 'v1/',
  V2_API_URL: REACT_APP_API_URL + 'v2/',
  V3_API_URL: REACT_APP_API_URL + 'v3/',
  BACKEND_URL: REACT_APP_BACKEND_URL,
  SOCKET_URL: REACT_APP_SOCKET_URL,
  FRONEND_URL: REACT_APP_FRONTEND_URL,
  FRONEND_URL_PRINT: REACT_APP_FRONEND_URL_PRINT,
  CAPTCHA_SITE_KEY: REACT_APP_CAPTCHA_SITE_KEY,
  ENCKEY: REACT_APP_ENSEC,

  FIREBASE: {
    APIKEY: REACT_APP_APIKEY,
    AUTHDOMAIN: REACT_APP_AUTHDOMAIN,
    PROJECTID: REACT_APP_PROJECTID,
    STORAGEBUCKET: REACT_APP_STORAGEBUCKET,
    MESSAGINGSENDERID: REACT_APP_MESSAGINGSENDERID,
    APPID: REACT_APP_APPID,
    MEASUREMENTID: REACT_APP_MEASUREMENTID,
  },

  SITENAME: 'Unitic Exchange',
  TFA: {
    downLoadLink: {
      googleApp:
        'https://apps.apple.com/us/app/google-authenticator/id388497605',
      playstoreApp:
        'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_IN&gl=US&pli=1',
    },
  },
  timer: {
    resendOtp: 60,
  },
}

export default KEY
